<template>
  <div class="audio_content" @click="handlePlayAudio">
    <div class="circle circle-dot"></div>
    <div class="circle circle1 clip1" :class="{ animate1: msgItem.id == audioMsgId }"></div>
    <div class="circle circle2 clip1" :class="{ animate2: msgItem.id == audioMsgId }"></div>
  </div>
</template>
<script>
import { computed, provide, inject, onMounted } from "vue";
import { useStore } from "vuex";
import { isIncludesURL } from "@/utils/securityutils";

export default {
  props: {
    msgItem: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const bus = inject("$eventBus");
    const eventbusCms = inject("eventbusCms");
    provide("msgItem", props.msgItem);
    let store = useStore();

    const audioMsgId = computed(() => store.state.profile.audioMsgId);

    const handlePlayAudio = async () => {
      let msg = props.msgItem?.msg;
      if (!isIncludesURL(msg)) {
        return;
      }
      bus.emit(eventbusCms.play_audio_msg, { id: props.msgItem?.id, audioUrl: msg });
    };

    onMounted(() => {});

    return {
      audioMsgId,
      handlePlayAudio,
    };
  },
};
</script>

<style lang="scss" scoped>
.audio_content {
  position: relative;
  height: 37px;
  width: 40px;
  cursor: pointer;
}

</style>
